<template lang="html">
  <div class="faq">
    <div class="">
      <h2 class="title">Kérdések és válaszok az oldallal kapcsolatban</h2>
    </div>
    <div class="faqlist">
      <v-row justify="center">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>Mi ez az oldal?</v-expansion-panel-header>
            <v-expansion-panel-content>
              Ez az oldal egy elképzelt menhely oldala, melyet a felhasználók jogosultságuk szerint
              tudnak karbantartani. Tovább a DEMO leírásához
              <v-icon @click="$router.push('demo')">
                mdi-arrow-right
              </v-icon>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Ki és miért készítette ezt az oldalt?</v-expansion-panel-header>
            <v-expansion-panel-content>
              Zsigmond Ildikó vagyok, nemrég kezdtem szoftverfejlesztéssel foglalkozni.
              Ez az oldal a portfólióm része. Látogassa meg oldalamat: <a href="http://zsigmondildiko.hu" target="_blank">zsigmondildiko.hu</a>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Sokba kerül egy ilyen oldal?</v-expansion-panel-header>
            <v-expansion-panel-content>
              Sajnos valószínűleg többe, mint amit egy kisebb non-profit szervezet megengedhet magának.
              Mivel magam is szeretem az állatokat, az oldal forráskódját szabadon elérhetővé teszem,
              valamint egy szerencsés szervezetnek felajánlok egy kis extra segítséget is a beállításokhoz.
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Nem tetszik a design!</v-expansion-panel-header>
            <v-expansion-panel-content>
              Ez egy demo oldal, nem a design volt a fő szempont.<br/>
              A felhasznált képeket a <a href="http://pexels.com" target="_blank">pexels.com</a> oldalról töltöttem le, valamint a hátteret sem én rajzoltam.
              A pontos forrásokat a közzétett kód mappáiban ('sources') feltüntettem.<br/>
              Amennyiben arra igény van, természetesen egyedi design is lehetséges.
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Más adatokat is lementenék a védencekről!</v-expansion-panel-header>
            <v-expansion-panel-content>
              Mivel az oldalhoz tartozó API backendet is én írtam, természetesen ezek változtatása is megoldható.
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
      </v-row>

      <h3 class="innertitle">Technikai jellegű kérdések</h3>

      <v-row justify="center">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>A backend</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                Az oldal backendje egy Python/Django/Django Rest FrameWork API. Database engine: SQlite.
              </p>
              <a href="https://bitbucket.org/zsigil/shelter-backend/src/master/" target="_blank">A forráskód innen szabadon letölthető.</a>
              <p>
                Ez a demo a pythonanywhere.com szerverén fut, <a href="http://zsigil.pythonanywhere.com/api/animals/" target="_blank">itt</a>.
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>A frontend</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                Az oldal frontendjét Vue/Vuetify segítségével készítettem.
              </p>
              <a href="https://bitbucket.org/zsigil/shelter-frontend/src/master/" target="_blank">A forráskód innen szabadon letölthető.</a>
              <p>
                Ez a demo a Firebase szerveréről fut.
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Miért van lekorlátozva a feltölthető adatlapok száma?</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                Azért, mert a felhasználónevek ismeretében mindenki/bárki feltölthet, és ezt korlátozni kell.
                Ennyi adatlap elég arra, hogy az oldal működését be tudjam mutatni.
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Miért nem lehet nagyobb képeket feltölteni?</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                Elsősorban ez nem képgaléria. Ahogy nő a feltöltött állatok száma, nő a tárhelyen elfoglalt hely is,
                a képek rengeteg helyet tudnak elfoglalni.
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Akkor nem lehet több adatlap/nagyobb kép?</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                Dehogynem, minden pénz kérdése. Maguk az adatlapok,
                ha ilyen méretű képekkel vannak feltöltve (pl. 2 kép/védenc), nem sok tárhelyet foglalnak.
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Hogyan tudom én karbantartani az oldalt?</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                Az oldalon biztosított felhasználói felületen lehet adatlapokat hozzáadni/módosítani/törölni.<br/>
                Felhasználókat létrehozni az admin-felületről lehet. Az admin-felület alkalmazása sem bonyolult,
                de alap felhasználóknak nem javasolt a használata. (A demo oldalon feltüntetett felhasználók egyike sem rendelkezik admin jogosultságokkal!)<br/>
                Az oldal többi részének frissítéséhez már komolyabb ismeretek szükségesek.
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Akkor hogyan lesz ebből személyre szabott oldal?</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                Úgy, hogy az elején ki kell találni, hogy mi/hogyan legyen az oldalon.
                A számlaszám, bemutatkozás, menhely bemutatása, az oldal design-ja nem változik mindennap, csak a védencek,
                az ő adatlapjukat meg könnyen lehet szerkeszteni.
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Mégis változtatni szeretnék valamit!</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                Természetesen minden lehetséges, innentől pénzügyi kérdés.
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
      </v-row>

      <h3 class="innertitle">Pénzügyi kérdések</h3>

      <v-row justify="center">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>Mennyibe kerül a kód?</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                A forráskód <a href="https://bitbucket.org/zsigil/">innen</a> ingyen letölthető.
                Köszönöm, ha a kész oldalon hivatkozik rám.
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Mennyibe kerülnek a szerverek?</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                Frontend: amennyiben Firebase-t használunk, a frontend hostingja alapesetben egy Google felhasználói fiókkal ingyenesen igénybe vehető.
              </p>
              <p>
                Backend: a pythonanywhere.com oldalon 512MB-ig ingyenes a tárhely, és bár kicsi a sávszélesség, ez csak nagyobb forgalomnál jelenthet problémát.
                Havi 5 dollárért már 1GB-nyi tárhelyet kapunk, havi 12 dollárért pedig már egészen komoly sávszélesség és 5GB jár.
                Kb 100MB-ot elfoglal maga a rendszer, a többi helyet lényegében a képek foglalják majd el.<br/>
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel>
            <v-expansion-panel-header>Mibe kerül, ha én magam nem tudom beállítani?</v-expansion-panel-header>
            <v-expansion-panel-content>
              <p>
                Az oldal személyre szabása, szerverekre feltöltése, valamint frissítése (az adatlapok frissítésén kívül)
                ún. full-stack fejlesztőt igényel. Egy ilyen fejlesztő óradíja ma Magyarországon 8-12ezer forint között van.
              </p>
              <p>
                A non-profit szervezeteknek ezen óradíj feléért segítek az általam készített oldalak frissen tartásában,
                amennyiben hivatkozásként elhelyezik nevemet/elérhetőségemet az oldalon.
              </p>
              <p class="kiemelt">
                Ezen kívül, egy általam választott magyarországi menhelynek felajánlom,
                hogy térítésmentesen elkészítem az erre az oldalra épülő, de személyre szabott oldalukat (racionális keretek között),
                amennyiben biztosítják számomra az információkat és képeket.
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>


        </v-expansion-panels>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.faq{
  width: 90%;
  max-width: 800px;
  margin: 0 auto;
  padding-bottom: 80px;
}

h2.title{
  text-align: center;
  margin-top: 30px;
  margin-bottom: 40px;
}

.faq .innertitle{
  margin-top: 30px;
  margin-bottom: 20px;
}

.theme--light.v-expansion-panels .v-expansion-panel {
    background-color: transparent;
    color: rgba(0, 0, 0, 0.87);

    .v-expansion-panel-header{
      color: $darkbrown;
      font-weight: bold;
    }

    .v-expansion-panel-content{
      text-align: justify;

      a,
      a:visited,
      &:link{
        text-decoration: none;
        color: $darkbrown;
        font-weight: bold;

        &:hover,
        &:active
        {
          color: $lightbrown;
        }
      }

      .kiemelt{
        color: $darkbrown;
      }
    }
}
</style>
